module.exports = __webpack_public_path__ + "img/refresh1.a14504e5.png";